export function formatCurrency(value) {
  let convertedValue = value.toString().replace(/\D/g, "")?.substr(0, 10);
  convertedValue = convertedValue.replace(/(\d)(\d{2})$/, "$1.$2");
  // convertedValue = convertedValue.replace(/(?=(\d{3})+(\D))\B/g, ",");
  return convertedValue;
}

export function decimalValue(value) {
  let convertedValue = value.toString().replace(/\D/g, "").substr(0, 5); // 10 digits before + 1 digit for decimal
  if (convertedValue.length < 2) return convertedValue;
  return convertedValue.replace(/(\d+)(\d{1})$/, "$1.$2");
};

export function number(value) {
  return value.replace(/[^\d]/g, "");
}

export function alphaNumeric(value) {
  return value.replace(/[^a-zA-Z0-9\s]/g, "");
}

export function onlyAlphabetWithSpace(value) {
  return value.replace(/[^a-zA-Z ]/g, "");
}

export function maxLength(count) {
  return (value) => value.substr(0, count);
}

export function formatPhoneNumbers(value) {
  // Remove all non-digit characters except commas
  const cleanedValue = value.replace(/[^\d,]/g, "");

  // Split by commas and filter out any non-10 digit values
  const phoneNumbers = cleanedValue
    .split(",")
    .filter((phone) => phone.length === 10);

  // Join the valid phone numbers back with commas
  return phoneNumbers.join(",");
}

export function stripTags(html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}

export function formatTimeAgo(dateString) {
  const date = new Date(dateString);
  const now = new Date();

  // Calculate the difference in days
  const diffInTime = now - date;
  const diffInDays = Math.floor(diffInTime / (1000 * 60 * 60 * 24));

  if (diffInDays === 0) return "Today";
  if (diffInDays === 1) return "Yesterday";
  if (diffInDays <= 7) return `${diffInDays} days ago`;

  // Format for dates older than 7 days (MM/DD/YYYY)
  return date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
}
